import styled from "styled-components";

export const Tabs = styled.div`
  border-radius: 16px;
  display: flex;
  background: var(--fill-secondary);
  align-items: center;
  padding: 2px;
`;

export const TabItem = styled.button`
  border: 0;
  outline: 0;
  cursor: pointer;
  letter-spacing: 0.03em;
  transition: 300ms ease-out;
  padding: 14px 20px 14px 12px;
  border-radius: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  font-size: 12px;
  gap: 8px;
  background: transparent;
  -webkit-tap-highlight-color: transparent;
  color: var(--text-primary);
  &.active {
    background: var(--fill-elevated);
    box-shadow: 0px 2px 1px rgba(51, 20, 0, 0.04),
      0px 4px 8px rgba(51, 20, 0, 0.08);
  }
`;
